import React from "react";

// Styles //
import styled from "styled-components";
import { THEME_COLORS } from "../../../../ThemeConfig";

// Components //
import BottomNavigation from "../../../general/BottomNavigation";

// images & icons
import about from "../../../../assets/images/about-group.png";
import aboutVision from "../../../../assets/images/about-mission.png";
import aboutMission from "../../../../assets/images/about-vission.png";
import Header from "../../../general/Header";

function About() {
    return (
        <>
            <Container>
                <PageTitle>About Us</PageTitle>
                <TopMainContainer>
                    <TopSubContainer>
                        <TopLeftContainer>
                            <LeftBottomContainer>
                                <SubHeading>Our Story</SubHeading>
                                <Description>
                                    Mindmitra is a client-centric company providing affordable access to mental wellness.
                                    <br /><br />
                                    Leveraging advanced technology, we connect individuals with qualified multi-intervention professionals who prioritize human connection and empathy.
                                    <br /><br />
                                    Our platform is designed to be a companion for every Indian, breaking stigma and fostering a culture of mental health awareness.
                                </Description>
                            </LeftBottomContainer>
                        </TopLeftContainer>
                        <TopRightContainer>
                            <ImageContainer>
                                <Image src={about} alt="Mind Mitra" />
                            </ImageContainer>
                        </TopRightContainer>
                    </TopSubContainer>
                </TopMainContainer>
                <BottomMainContainer>
                    <BottomSubContainer>
                        <MissionContainer>
                            <MissionLeftContainer>
                                <MissionHeading>Mission</MissionHeading>
                                <MissionDescription>
                                    &ldquo;To be the companion for every Indian to achieve mental wellness.&rdquo;
                                </MissionDescription>
                            </MissionLeftContainer>
                            <MissionImageContainer>
                                <MissionImage src={aboutMission} alt="Mission" />
                            </MissionImageContainer>
                        </MissionContainer>
                        <VisionContainer>
                            <VisionImageContainer>
                                <VisionImage src={aboutVision} alt="Vision" />
                            </VisionImageContainer>
                            <VisionLeftContainer>
                                <VisionHeading>Vision</VisionHeading>
                                <VisionDescription>
                                    &ldquo;To be the most accessible and trustworthy wellness provider in the nation.&rdquo;
                                </VisionDescription>
                            </VisionLeftContainer>
                        </VisionContainer>
                    </BottomSubContainer>
                    <LeadershipSection>
                        <LeadershipHeading>Our Leadership</LeadershipHeading>
                        <LeadershipGrid>
                            <LeaderCard>
                                <LeaderImage src="/leadership-greeshma.png" alt="Ms. Greeshma E" />
                                <LeaderName>Ms. Greeshma E</LeaderName>
                                <LeaderRole>Founder and Psychologist</LeaderRole>
                            </LeaderCard>
                            <LeaderCard>
                                <LeaderImage src="/leadership-ashly.png" alt="Ms. Ashly Tom" />
                                <LeaderName>Ms. Ashly Tom</LeaderName>
                                <LeaderRole>Cofounder and Psychologist</LeaderRole>
                            </LeaderCard>
                        </LeadershipGrid>
                    </LeadershipSection>
                </BottomMainContainer>
            </Container>
            <BottomNavigation />
        </>
    );
}

export default About;

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    background: ${THEME_COLORS.page_bg_neutral};
    padding-bottom: 24px;
`;
const PageTitle = styled.h1`
    font-family: "DM_sans_medium";
    font-size: 28px;
    color: ${THEME_COLORS.secondary};
    text-align: center;
    margin: 24px 0 16px;
    letter-spacing: -0.02em;
    @media all and (max-width: 480px) {
        font-size: 24px;
        margin: 20px 0 12px;
    }
`;
const TopMainContainer = styled.div`
    display: inline-flex;
    padding: 40px 32px;
    flex-direction: column;
    align-items: flex-start;
    width: 80%;
    max-width: 1100px;
    margin: 0 auto 24px;
    gap: 8px;
    background: ${THEME_COLORS.card_bg};
    border-radius: 16px;
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    border: 1px solid ${THEME_COLORS.light_300};
    @media all and (max-width: 480px) {
        width: 90%;
        padding: 24px 20px;
    }
`;

const TopSubContainer = styled.div`
    display: flex;
    /* width: 80%; */
    justify-content: center;
    align-items: center;
    gap: 18.528px;
    margin: 0 auto;
    @media all and (max-width: 1080px) {
        flex-wrap: wrap;
        text-align: center;
    }
    @media all and (max-width: 480px) {
        width: 95%;
    }
`;
const TopLeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16.111px;
    width: 50%;
    @media all and (max-width: 1080px) {
        width: 90%;
    }
`;
const LeftBottomContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8.056px;
    align-self: stretch;
    border-radius: 13.694px;
    /* backdrop-filter: blur(16.916667938232422px); */
    @media all and (max-width: 1080px) {
        align-items: center;
    }
`;
const SubHeading = styled.h5`
    color: ${THEME_COLORS.text_title};
    font-family: "DM_sans_medium";
    font-size: 22px;
    line-height: 1.3;
    margin-bottom: 12px;
    @media all and (max-width: 1080px) {
        width: 100%;
        text-align: center;
    }
    @media all and (max-width: 480px) {
        font-size: 20px;
    }
`;
const Description = styled.p`
    color: ${THEME_COLORS.text_para};
    font-family: "DM_sans";
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    text-align: justify;
    width: 90%;
    margin: 0;
`;
const TopRightContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 18px;
    width: 50%;
    @media all and (max-width: 1080px) {
        width: 100%;
    }
`;
const ImageContainer = styled.div`
    border-radius: 12px;
    overflow: hidden;
    box-shadow: ${THEME_COLORS.elevation_user_u4};
`;
const Image = styled.img`
    display: block;
    max-width: 100%;
    height: auto;
    object-fit: cover;
`;
const BottomMainContainer = styled.div`
    display: flex;
    width: 80%;
    max-width: 1100px;
    padding: 40px 32px 50px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    background: ${THEME_COLORS.card_bg};
    margin: 0 auto;
    border-radius: 16px;
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    border: 1px solid ${THEME_COLORS.light_300};
    @media all and (max-width: 480px) {
        width: 90%;
        padding: 24px 20px 110px;
    }
`;

const BottomSubContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    width: 100%;
`;
const MissionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;
    flex: 1 0 0;
    align-self: stretch;
    padding: 24px;
    border-radius: 12px;
    background: ${THEME_COLORS.accent_teal_soft};
    border-left: 4px solid ${THEME_COLORS.primary};
    @media all and (max-width: 1080px) {
        flex-wrap: wrap;
    }
`;
const MissionLeftContainer = styled.div`
    display: flex;
    padding: 8px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 50%;
    @media all and (max-width: 1080px) {
        width: 80%;
        align-items: center;
        text-align: center;
    }
    @media all and (max-width: 480px) {
        width: 100%;
    }
`;
const MissionHeading = styled.h4`
    color: ${THEME_COLORS.secondary};
    font-family: "DM_sans_medium";
    font-size: 20px;
    line-height: 1.3;
    margin: 0;
`;
const MissionDescription = styled.p`
    color: ${THEME_COLORS.text_para};
    font-family: "DM_sans";
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    text-align: justify;
    width: 90%;
    margin: 0;
`;
const MissionImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    @media all and (max-width: 1080px) {
        width: 100%;
    }
`;
const MissionImage = styled.img`
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    object-fit: cover;
`;

const VisionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;
    flex: 1 0 0;
    align-self: stretch;
    padding: 24px;
    border-radius: 12px;
    background: ${THEME_COLORS.accent_blue_soft};
    border-left: 4px solid ${THEME_COLORS.secondary};
    @media all and (max-width: 1080px) {
        flex-wrap: wrap-reverse;
    }
`;

const VisionLeftContainer = styled.div`
    display: flex;
    padding: 8px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 50%;
    @media all and (max-width: 1080px) {
        width: 80%;
        align-items: center;
        text-align: center;
    }
    @media all and (max-width: 480px) {
        width: 100%;
    }
`;
const VisionHeading = styled.h4`
    color: ${THEME_COLORS.secondary};
    font-family: "DM_sans_medium";
    font-size: 20px;
    line-height: 1.3;
    margin: 0;
`;
const VisionDescription = styled.p`
    color: ${THEME_COLORS.text_para};
    font-family: "DM_sans";
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    text-align: justify;
    width: 90%;
    margin: 0;
`;
const VisionImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    @media all and (max-width: 1080px) {
        width: 100%;
    }
`;
const VisionImage = styled.img`
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    object-fit: cover;
`;

const LeadershipSection = styled.div`
    width: 100%;
    margin-top: 16px;
    padding-top: 32px;
    border-top: 1px solid ${THEME_COLORS.light_300};
`;
const LeadershipHeading = styled.h3`
    color: ${THEME_COLORS.secondary};
    font-family: "DM_sans_medium";
    font-size: 22px;
    text-align: center;
    margin: 0 0 28px;
    letter-spacing: -0.02em;
    @media all and (max-width: 480px) {
        font-size: 20px;
    }
`;
const LeadershipGrid = styled.div`
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
    @media all and (max-width: 768px) {
        gap: 32px;
    }
`;
const LeaderCard = styled.div`
    text-align: center;
    max-width: 280px;
    padding: 24px 20px;
    background: ${THEME_COLORS.surface_soft};
    border-radius: 16px;
    border: 1px solid ${THEME_COLORS.light_300};
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    transition: box-shadow 0.2s, border-color 0.2s;
    &:hover {
        box-shadow: ${THEME_COLORS.elevation_user_u3};
        border-color: ${THEME_COLORS.primary};
    }
`;
const LeaderImage = styled.img`
    width: 180px;
    height: 180px;
    object-fit: cover;
    border-radius: 50%;
    margin: 0 auto 20px;
    display: block;
    border: 3px solid ${THEME_COLORS.card_bg};
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    @media all and (max-width: 480px) {
        width: 140px;
        height: 140px;
    }
`;
const LeaderName = styled.h4`
    color: ${THEME_COLORS.text_title};
    font-family: "DM_sans_medium";
    font-size: 18px;
    margin: 0 0 6px;
    line-height: 1.3;
`;
const LeaderRole = styled.p`
    color: ${THEME_COLORS.primary};
    font-family: "DM_sans";
    font-size: 14px;
    margin: 0;
    line-height: 1.4;
`;

// import React from "react";

// // Styles //
// import styled from "styled-components";

// // Components //
// import BottomNavigation from "../../../general/BottomNavigation";

// // images & icons
// import about from "../../../../assets/images/about-group.png";
// import aboutVision from "../../../../assets/images/about-mission.png";
// import aboutMission from "../../../../assets/images/about-vission.png";

// function About() {
//   return (
//     <>
//       <Container>
//         <TopMainContainer>
//           <TopSubContainer>
//             <TopLeftContainer>
//               <Heading>Enbrace Mindfulness Elevate your well-being</Heading>
//               <LeftBottomContainer>
//                 <SubHeading>About Mind Mitra</SubHeading>
//                 <Description>
//                   Mental health is a significant issue in many countries, with
//                   many individuals struggling to access timely and effective
//                   care due to a variety of barriers. One potential solution to
//                   this issue is the use of online platforms for mental health
//                   appointments. These platforms can provide a convenient and
//                   private way for individuals to access therapy from the comfort
//                   of their own home.
//                 </Description>
//               </LeftBottomContainer>
//             </TopLeftContainer>
//             <TopRightContainer>
//               <ImageContainer>
//                 <Image src={about} alt="Icon" />
//               </ImageContainer>
//             </TopRightContainer>
//           </TopSubContainer>
//         </TopMainContainer>
//         <BottomMainContainer>
//           <BottomSubContainer>
//             <MissionContainer>
//               <MissionLeftContainer>
//                 <MissionHeading>Mission</MissionHeading>
//                 <MissionDescription>
//                   Mental health is a significant issue in many countries, with
//                   many individuals struggling to access timely and effective
//                   care due to a variety of barriers. One potential solution to
//                   this issue is the use of online platforms for mental health
//                   appointments. These platforms can provide a convenient and
//                   private way for individuals to access therapy from the comfort
//                   of their own home.
//                 </MissionDescription>
//               </MissionLeftContainer>

//               <MissionImageContainer>
//                 <MissionImage src={aboutMission} alt="Image" />
//               </MissionImageContainer>
//             </MissionContainer>
//             <VisionContainer>
//               <VisionImageContainer>
//                 <VisionImage src={aboutVision} alt="Image" />
//               </VisionImageContainer>

//               <VisionLeftContainer>
//                 <VisionHeading>Vision</VisionHeading>
//                 <VisionDescription>
//                   Mental health is a significant issue in many countries, with
//                   many individuals struggling to access timely and effective
//                   care due to a variety of barriers. One potential solution to
//                   this issue is the use of online platforms for mental health
//                   appointments. These platforms can provide a convenient and
//                   private way for individuals to access therapy from the comfort
//                   of their own home.
//                 </VisionDescription>
//               </VisionLeftContainer>
//             </VisionContainer>
//           </BottomSubContainer>
//         </BottomMainContainer>
//       </Container>
//       <BottomNavigation />
//     </>
//   );
// }

// export default About;

// const Container = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   overflow: scroll;
// `;
// const TopMainContainer = styled.div`
//   display: inline-flex;
//   padding: 30px 0;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 8.056px;
//   background: #fff;
// `;

// const TopSubContainer = styled.div`
//   display: flex;
//   width: 80%;
//   justify-content: center;
//   align-items: center;
//   gap: 18.528px;
//   margin: 0 auto;
//   @media all and (max-width: 1080px) {
//     flex-wrap: wrap;
//     text-align: center;
//   }
//   @media all and (max-width: 480px) {
//     width: 95%;
//   }
// `;
// const TopLeftContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 16.111px;
//   width: 50%;
//   @media all and (max-width: 1080px) {
//     width: 90%;
//   }
// `;
// const Heading = styled.h4`
//   color: #000;
//   font-family: "DM_Sans";
//   font-size: 32px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: normal;
//   width: 90%;
//   @media all and (max-width: 1080px) {
//     width: 100%;
//     text-align: center;
//   }
// `;
// const LeftBottomContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 8.056px;
//   align-self: stretch;
//   border-radius: 13.694px;
//   backdrop-filter: blur(16.916667938232422px);
//   @media all and (max-width: 1080px) {
//     align-items: center;
//   }
// `;
// const SubHeading = styled.h5`
//   color: #3e3e53;
//   font-family: "DM_Sans";
//   font-size: 24px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: normal;
//   @media all and (max-width: 1080px) {
//     width: 100%;
//     text-align: center;
//   }
// `;
// const Description = styled.span`
//   color: #7a838a;
//   font-family: "DM_Sans";
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 20px;
//   width: 90%;
// `;
// const TopRightContainer = styled.div`
//   display: flex;
//   width: 870px;
//   justify-content: center;
//   align-items: center;
//   gap: 18.528px;
//   width: 50%;
// `;
// const ImageContainer = styled.div``;
// const Image = styled.img``;
// const BottomMainContainer = styled.div`
//   display: flex;
//   width: 80%;
//   padding: 30px 0 50px 0;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   gap: 8.065px;
//   background: #fff;
//   margin: 0 auto;
//   @media all and (max-width: 480px) {
//     width: 95%;
//     padding-bottom: 110px;
//   }
// `;

// const BottomSubContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 29.035px;
// `;
// const MissionContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 24.196px;
//   flex: 1 0 0;
//   align-self: stretch;
//   @media all and (max-width: 1080px) {
//     flex-wrap: wrap;
//   }
// `;
// const MissionLeftContainer = styled.div`
//   display: flex;
//   padding: 12.098px;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 8.065px;
//   border-radius: 12.098px;
//   width: 50%;
//   @media all and (max-width: 1080px) {
//     width: 80%;
//     align-items: center;
//     text-align: center;
//   }
// `;
// const MissionHeading = styled.h4`
//   color: #000;
//   font-family: "DM_Sans";
//   font-size: 24px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: normal;
// `;
// const MissionDescription = styled.span`
//   color: #7a838a;
//   font-family: "DM_Sans";
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 20px;
// `;
// const MissionImageContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 50%;
// `;
// const MissionImage = styled.img``;

// const VisionContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 24.196px;
//   flex: 1 0 0;
//   align-self: stretch;

//   @media all and (max-width: 1080px) {
//     flex-wrap: wrap-reverse;
//   }
// `;

// const VisionLeftContainer = styled.div`
//   display: flex;
//   padding: 12.098px;
//   flex-direction: column;
//   align-items: flex-start;
//   gap: 8.065px;
//   border-radius: 12.098px;
//   width: 50%;
//   @media all and (max-width: 1080px) {
//     width: 80%;
//     align-items: center;
//     text-align: center;
//   }
// `;
// const VisionHeading = styled.h4`
//   color: #000;
//   font-family: "DM_Sans";
//   font-size: 24px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: normal;
// `;
// const VisionDescription = styled.span`
//   color: #7a838a;
//   font-family: "DM_Sans";
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 20px;
// `;
// const VisionImageContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 50%;
// `;
// const VisionImage = styled.img``;
